$(document).ready(function () {
	let $toggleImage = $('[data-toggle=prd-image]');

	$toggleImage.click(function () {
		let $container = $('.vg-catalog-show--slider');
		let $thumbs = $container.find('.image-area').find('[data-original]');
		let thumbs = [];
		let key = $(this).data('key');

		if ($thumbs.length) {
			$.merge($thumbs.slice(key), $thumbs.slice(0, key)).each(function () {
				thumbs.push({
					src: $(this).data('original'),
					thumb: $(this).data('thumb')
				});
			});
		} else {
			thumbs.push({
				src: $(this).data('original'),
				thumb: $(this).data('thumb')
			});
		}

		fancybox.Fancybox.show(thumbs, {
			l10n: {
				CLOSE: "Закрыть",
				NEXT: "Следующий",
				PREV: "Предыдущий",
				TOGGLE_FULLSCREEN: 'На весь экран',
				TOGGLE_SLIDESHOW: 'Начать показ',
				TOGGLE_ZOOM: 'Увеличить',
				TOGGLE_THUMBS: 'Переключить миниатюры',
				MODAL: "Вы можете закрыть это модальное окно с помощью клавиши ESC.",
				ERROR: "Что-то пошло не так. Пожалуйста, повторите попытку позже",
				IMAGE_ERROR: "Изображение не найдено",
				ELEMENT_NOT_FOUND: "HTML Element Not Found",
				AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
				AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
				IFRAME_ERROR: "Error Loading Page",
			},
			Toolbar: {
				display: [
					{ id: "prev", position: "center" },
					{ id: "counter", position: "center" },
					{ id: "next", position: "center" },
					"zoom",
					"slideshow",
					"fullscreen",
					"thumbs",
					"close",
				],
			}
		});
		
		return false;
	});
});
